module.exports = __webpack_public_path__ + "img/admin-console-second-arrow.b36f09e0.svg";